import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormWindowsEntryPageContainer } from './audit-form-windows-entry-page.container';
import { AuditFormWindowsEntryPageMenu } from './audit-form-windows-entry-page-menu';
import { useAuditFormWindowsEntryPageViewModel } from './audit-form-windows-entry-page.view-model';

export const AuditFormWindowsEntryPage = () => {
  const logger = useLogger('pages/audit-form-windows-entry');

  const viewModel = useAuditFormWindowsEntryPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  const { mainMenu, isDeleteDisabled, onDelete } = viewModel;

  return (
    <FormPageLayout
      title="Window"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}
      headerChildren={
        viewModel.loadAuditFormState.state === 'success' && (
          <AuditFormWindowsEntryPageMenu
            onClose={mainMenu.close}
            onOpen={mainMenu.open}
            isOpen={mainMenu.isOpen}
            anchorEl={mainMenu.anchorEl}
            onDelete={onDelete.bind(null, { confirmed: false })}
            isDeleteDisabled={isDeleteDisabled}
          />
        )
      }>
      <CenteredLayout horizontal>
        <AuditFormWindowsEntryPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
